import { tasksRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';

export const useCreateTask = () =>
  useMutation<number, unknown, FormData>((data) => tasksRepo.createTask(data));
